import { render, staticRenderFns } from "./mod5.vue?vue&type=template&id=ac99bd46&scoped=true&"
import script from "./mod5.vue?vue&type=script&lang=js&"
export * from "./mod5.vue?vue&type=script&lang=js&"
import style0 from "./mod5.vue?vue&type=style&index=0&id=ac99bd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac99bd46",
  null
  
)

export default component.exports